"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(require("./IconButton"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/IconButton/index.js
// module id = 78
// module chunks = 0